import { ratesErrorCodes } from '@common/constants/ratesErrorCodes';
import { useTranslations } from '@lang';

type ErrorMessageType = {
  text: string;
  value: string | number;
} | null;

function isErrorMessage(error: ErrorMessageType | unknown): error is ErrorMessageType {
  return (error as ErrorMessageType)?.text !== undefined;
}

export const useRatesErrorMessage = (error: ErrorMessageType | unknown) => {
  const { t } = useTranslations();

  if (!isErrorMessage(error)) {
    return {
      title: t('app.noItemsFound'),
      message: t('room.adjustSearchFilters'),
    };
  }

  switch (error?.text) {
    case ratesErrorCodes.minimumOccupancy:
      return {
        title: t('room.minimumLengthOfStayTitle'),
        message: t('room.minimumLengthOfStayMessage').replace('min_length', `${error?.value}`),
      };

    case ratesErrorCodes.maximumOccupancy:
      return {
        title: t('room.maximumOccupancyTitle'),
        message: t('room.maximumOccupancyMessage'),
      };

    case ratesErrorCodes.maximumLengthOfStay:
      return {
        title: t('room.maximumLengthOfStayTitle'),
        message: 'room.maximumLengthOfStayMessage'.replace('max_length', `${error?.value}`),
      };

    case ratesErrorCodes.quantityIsZero:
      return {
        title: t('room.quantityZeroTitle'),
        message: t('room.quantityZeroMessage'),
      };

    case ratesErrorCodes.priceIsZero:
      return {
        title: t('room.priceZeroTitle'),
        message: t('room.priceZeroMessage'),
      };

    default:
      return {
        title: t('app.noItemsFound'),
        message: t('room.adjustSearchFilters'),
      };
  }
};
